import {Select, SelectProps} from "antd";
import React from "react";
import {WarehouseType} from "../../api";

export const warehouseTypeTranslations: { [key in WarehouseType]: string } = {
    [WarehouseType.Tank]: 'Zbiornik',
    [WarehouseType.Other]: 'Inny',
    [WarehouseType.FinishedProducts]: "Wyrobów gotowych"
};

export default function WarehouseTypeSelect(props: SelectProps) {
    return <Select {...props} placeholder="Wybierz typ magazynu" style={{width: '100%'}}>
        {Object.values(WarehouseType).map((type) => (
            <Select.Option key={type} value={type}>
                {warehouseTypeTranslations[type]}
            </Select.Option>
        ))}
    </Select>
}
